import { createContext, useContext } from 'react'

// Maps action ID → tool call ID of the most recent create_staged_action result
// across the entire conversation. StagedActionsSection uses this to suppress
// stale renders: skip a tool call's action if map.get(actionId) !== toolCall.id.
export const LatestStagedActionContext = createContext<ReadonlyMap<string, string> | null>(null)
export const useLatestStagedActionContext = () => useContext(LatestStagedActionContext)

// Action IDs whose most recent create_staged_action tool call lives in a turn
// BEFORE the last user message — i.e. a completed card already renders for them
// in a prior turn. The pending_context preview consults this to suppress those
// items so the card isn't duplicated beneath the latest user message. Actions
// created by the active turn (at/after the last user group) are intentionally
// excluded so the preview still bridges until that turn's card reveals.
export const StagedActionsOwnedByPriorTurnContext = createContext<ReadonlySet<string> | null>(null)
export const useStagedActionsOwnedByPriorTurn = () => useContext(StagedActionsOwnedByPriorTurnContext)
